import { type ImageBackgroundThemeTyping } from '@shared/typings';
import { getImageBackgroundTheme } from './colors';

export const getImageBackground = async(path: string): Promise<ImageBackgroundThemeTyping> => {
    const isFullUrl = /^https?:\/\//u.test(path);
    const cloudName = import.meta.env.VITE_CLOUDINARY_CLOUDNAME ?? '';
    const imageUrl = isFullUrl ? path : `https://res.cloudinary.com/${cloudName}/image/upload/${path}`;
    return getImageBackgroundTheme(imageUrl);
};
